import React, { useState, useEffect } from 'react';
import Link from 'react-router-dom/Link';
import { connect, useDispatch } from 'react-redux';
import imagesLoaded from 'imagesloaded';

import ProductSix from '../product-six';
import ProductEight from '../product-two';
import QuickView from '../common/quickview';
import Pagination from '../../pagination';

import { resetFilters } from '../../../../actions/variantFilterActions';

import store from '../../../../store';

import { addToCart, toggleWishlist, addToCompare, showQuickViewModal, filterSort } from '../../../../actions';
import { getVisibleProducts } from '../../../../services';

function ProductList( props ) {
    let { column, filterSort, products, filters, addToCart, toggleWishlist, addToCompare, showQuickViewModal } = props;

    const dispatch = useDispatch();

    const [ start, setStart ] = useState( 0 );
    const [ cols, setCols ] = useState( column );

    let variants = props.variants;
    const [ toggle, setToggle ] = useState( 0 );
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [width]);

   useEffect(()=>{
    dispatch(resetFilters());
   })

    useEffect( () => {
        document.querySelector( '.skeleton-body.skel-shop-products' ).classList.remove( 'loaded' );
        document.querySelector( '.skeleton-body.skel-shop-sidebar' ).classList.remove( 'loaded' );

        let imgLoad = imagesLoaded( ".products", { background: true } );

        imgLoad.on( 'done', function ( instance, image ) {
            document.querySelector( '.skeleton-body.skel-shop-products' ).classList.add( 'loaded' );
            document.querySelector( '.skeleton-body.skel-shop-sidebar' ).classList.add( 'loaded' );
        } );

        setCols( column );
    }, [ cols, column ] )

    useEffect( () => {
        document.querySelector( '.skeleton-body.skel-shop-products' ).classList.remove( 'loaded' );
        document.querySelector( '.skeleton-body.skel-shop-products' ).classList.add( 'loaded' );
    }, [ variants ] )

    useEffect( () => {
        document.querySelector( '.skeleton-body.skel-shop-products' ).classList.remove( 'loaded' );

        let imgLoad = imagesLoaded( ".products", { background: true } );

        imgLoad.on( 'done', function ( instance, image ) {
            document.querySelector( '.skeleton-body.skel-shop-products' ).classList.add( 'loaded' );
        } );
    }, [ filters ] )

    function changePos( pos ) {
        setStart( pos );
        
        document.querySelector( '.skeleton-body.skel-shop-products' ) && document.querySelector( '.skeleton-body.skel-shop-products' ).classList.remove( 'loaded' );

        let imgLoad = imagesLoaded( ".products", { background: true } );

        imgLoad.on( 'done', function ( instance, image ) {
            document.querySelector( '.skeleton-body.skel-shop-products' ) && document.querySelector( '.skeleton-body.skel-shop-products' ).classList.add( 'loaded' );
        } );

        window.scrollTo( {
            top: 0
        } );
    }

    function changeFilter( e ) {
        filterSort( e.target.value );
        setStart( 0 );
    }

    function toggleSideBar() {
        if ( document.querySelector( 'body' ).classList.contains( 'sidebar-filter-active' ) ) {
            document.querySelector( 'body' ).classList.remove( 'sidebar-filter-active' );
        } else {
            document.querySelector( 'body' ).classList.add( 'sidebar-filter-active' );
        }
    }
    
    const grid = { "2cols": "col-6", "3cols": "col-6 col-md-4 col-lg-4", "4cols": "col-6 col-md-4 col-lg-4 col-xl-3" };
    const units = { "list": 6, "2cols": 6, "3cols": 9, "4cols": 12 };
    const itemsPerPage = units[ cols ];

    // products = getVisibleProducts( products, filters );

    return (
        <>
            <div className="toolbox">
                {/*<div className="toolbox-left">
                    <div className="toolbox-info">
                        Afficher <span>{ Math.min( itemsPerPage, products.length - start ) } of { products.length }</span> Products
                    </div>
                </div>*/}

                <div className="toolbox-right">
                    {/*<div className="toolbox-sort">*/}
                    {/*    <label htmlFor="sortby">Trier par :</label>*/}
                    {/*    <div className="select-custom">*/}
                    {/*        <select name="sortby" id="sortby" defaultValue={ filters.sortBy } className="form-control" onChange={ changeFilter }>*/}
                    {/*            <option value="default">Par défaut</option>*/}
                    {/*            <option value="a-z">A-Z</option>*/}
                    {/*            <option value="z-a">Z-A</option>*/}
                    {/*            <option value="prix-asc">Prix (ascendant)</option>*/}
                    {/*            <option value="prix-desc">Prix (descendant)</option>*/}
                    {/*        </select>*/}
                    {/*    </div>*/}

                    {/*    {width <= 600 && (*/}
                    {/*        <button htmlFor="filters" onClick={ toggleSideBar } style={{marginLeft: '50px'}}>Filtrer</button>*/}
                    {/*    )}*/}
                    {/*    */}
                    {/*    */}
                    {/*</div>*/}
                </div>
            </div>
            { variants &&
                <div className="products mb-3">
                { 'list' === cols ?
                    variants.map( ( item, index ) =>
                        <div key={ "seleton-" + index }>
                            <div className="skel-pro skel-pro-list">
                            </div>

                            <ProductEight
                                product={ item }
                            />
                        </div>
                    ) :

                    <div className="row">
                        { variants.map( ( item, index ) =>
                            <div className={ grid[ cols ] } key={ "product" + index } style={{boxShadow:"0 0 3px rgba(0,0,0,.1)", padding:0}}>
                                <div className="skel-pro">
                                </div>

                                <ProductEight
                                    product={ item }
                                    type="sidebar"
                                    onAddToCart={ addToCart }
                                    onToggleWishlist={ toggleWishlist }
                                    onAddToCompare={ addToCompare }
                                    showQuickView={ showQuickViewModal } />
                            </div>
                        ) }
                    </div>
                }
                <QuickView />
            </div>
            }
            

            { store.getState().variants.totalPages > 0 ? 
                store.getState().variants.totalPages > 1 ?
                    <Pagination
                        aclass={ `${'list' === props.cols ? '' : 'justify-content-center'}` }
                        count={ products.length }
                        unit={ itemsPerPage }
                        onChange={ changePos }
                        cols={ cols }
                        filters={ filters }
                    /> 
                    : 
                    ''  
            : 
            <div class="" style={{ textAlign: 'center', marginBottom: '5%', marginTop: '15%', marginRight: '25%' }}>
                <p style={{ fontSize: '35px', fontWeight: 'bold' }}>Aucun Produit a été trouvé</p>
            </div> 
            }
            
        </>
    );
}
export const mapStateToProps = ( state ) => {
    return {
        filters: state.filters,
        variants: state.variants.variants ? state.variants.variants : [],
        products: state.data.products ? state.data.products : []
    };
}

export default connect( mapStateToProps, { addToCart, resetFilters, toggleWishlist, addToCompare, showQuickViewModal, filterSort } )( ProductList );